// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"styles_sliderWrapper__Dd9o0","sliderLabel":"styles_sliderLabel__xF87M","slider":"styles_slider__I4qNQ"};